import React from "react";
// import your 5 images
import Img1 from "../../assets/crunch/05.webp";
import Img2 from "../../assets/crunch/06.webp";
import Img3 from "../../assets/crunch/07.webp";
import Img4 from "../../assets/crunch/08.webp";
import Img5 from "../../assets/crunch/09.webp";

export default function SixImageSections() {
  const images = [Img1, Img2, Img3, Img4, Img5];

  return (
    <>
      {/* Images Section */}
      <div className="flex flex-col gap-0 pt-16 pb-16">
        {images.map((image, index) => (
          <div key={index} className="relative w-full">
            {/* 🔹 Blurred Background */}
            <div
              className="absolute inset-0 bg-cover bg-center blur-2xl"
              style={{ backgroundImage: `url(${Img1})` }}
            ></div>

            {/* 🔹 Centered Sharp Container */}
            <div className="relative z-10 flex justify-center items-center py-0 px-4">
              <img
                src={image}
                alt={`Section ${index + 1}`}
                className="max-w-full h-auto"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Logo Section */}
      <section
        style={{
          width: "100%",
          minHeight: "25svh",
          scrollSnapAlign: "start",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          paddingBottom: "40px",
        }}
      >
        <img
          src="/logo.png"
          alt="Logo"
          style={{
            width: "80px",
            height: "auto",
            opacity: 0.9,
          }}
        />
      </section>
    </>
  );
}